<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="yuliang" ref="yuliang">
        <div class="select clearfix">
          <!-- 水库类型 -->
          <div class="reservoirType" >
                <span class="desc">水库类型：</span>
                  <!-- <el-select
                    v-model="reservoirType"
                    placeholder="请选择水库类型"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in optionsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                </el-select> -->
                <div>
                  <el-radio-group v-model='reservoirType'>
                  <el-radio label=''>全部</el-radio>
                  <el-radio label='Ⅳ'>小一型</el-radio>
                  <el-radio label='Ⅴ'>小二型</el-radio>
                  <el-radio label='large,middle'>大中型</el-radio>
                  </el-radio-group>
                </div>
          </div>
          <!-- 类别 -->
          <div class="storageType" >
                <span class="desc">类别：</span>
                <!-- <div>
                   <el-select
                    v-model="storageType"
                    placeholder="请选择类别"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in Type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                </el-select>
                </div> -->
                <div>
                  <el-radio-group v-model='storageType'>
                  <el-radio :label='1'>主汛</el-radio>
                  <el-radio :label='2'>梅汛</el-radio>
                  <el-radio :label='3'>台汛</el-radio>
                </el-radio-group>
              </div>
          </div>
          <!-- 时间 -->
            <div class="time" style="display: inline-block;">
              <span class="desc">时间:</span>
              <el-date-picker
                v-model="seletdate"
                value-format="yyyy-MM-dd HH:00"
                format="yyyy-MM-dd HH:mm"
                type="datetime"
                placeholder="选择日期"
              ></el-date-picker>
              <span id="select" @click="searchData">查询</span>
           </div>
          <div class="export">
             <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
          </div>
        </div>
       <div class="raintable" >
           <el-table v-loading="loading"  :data="tdata"  :max-height = "height" border style="width: 100%;">
             <el-table-column  type="index" width="70" label="序号" align="center" header-align="center">
            </el-table-column>
            <el-table-column  prop="addvnm" align="left" header-align="left" label="所在地" min-width="120" sortable>
            </el-table-column>
            <el-table-column  prop="stnm" align="left" header-align="left" label="水库名称" min-width="160" sortable>
            </el-table-column>
            <el-table-column prop="rainfallArea" align="right" header-align="right" label="集雨面积(km²)" min-width="160" sortable >
             <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.rainfallArea === undefined ">--</div>
                <div v-else>{{ scope.row.rainfallArea }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="storeLevel" align="right" header-align="center" :label="waterLabel" min-width="120">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.storeLevel === undefined ">--</div>
                <div v-else>{{ scope.row.storeLevel }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="normalStorage" align="right" header-align="right" :label="storageLabel" min-width="130">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.normalStorage === undefined ">--</div>
                <div v-else>{{ scope.row.normalStorage }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="water" align="center" header-align="center" label="当前水位(m)" min-width="110">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.water === undefined ">--</div>
                <div v-else>{{ scope.row.water }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="time" align="center" header-align="center" label="时间" min-width="150" >
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.time === undefined ">--</div>
                <div v-else>{{ getPartTime(scope.row.time) }}</div>
              </template>
             </el-table-column>
            <el-table-column prop="waterStorage"  align="center" label="当前库容（万m³）" min-width="150">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.waterStorage === undefined ">--</div>
                <div v-else>{{ scope.row.waterStorage }}</div>
              </template>
            </el-table-column>
              <el-table-column prop="impoundmentRate" align="center" label="蓄水率(%)" min-width="110">
                 <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.impoundmentRate === undefined ">--</div>
                <div v-else>{{ scope.row.impoundmentRate }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="overflowWarningWater" align="center" label="超汛限（m）" min-width="120">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.overflowWarningWater === undefined ">--</div>
                <div v-else>{{ scope.row.overflowWarningWater }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="warningWater" align="center" label="汛限值(m)" min-width="120">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.warningWater === undefined ">--</div>
                <div v-else>{{ scope.row.warningWater }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="netflStorage" align="center" label="可拦蓄水量(万m³)" min-width="120">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.netflStorage === undefined ">--</div>
                <div v-else>{{ scope.row.netflStorage }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="netRainfall" align="center" label="可拦蓄雨量(mm)" min-width="160">
               <template slot-scope="scope" style="text-align:center">
                <div v-if="scope.row.netRainfall === undefined ">--</div>
                <div v-else>{{ scope.row.netRainfall }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reportAnalysisTypes from '@/store/types/reportAnalysis'
import timer from '@/utils/timer'
export default {
  name: 'Report',
  data () {
    return {
      loading: true,
      timerFun: '',
      height: 10,
      aDDVCD: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      dialogVisible: false,
      sTID: '',
      time: '',
      dateselect: true,
      sID: 22,
      reservoirType: '',
      storageType: 1,
      seletdate: '',
      optionsType: [{
        value: 'Ⅳ',
        label: '小一型'
      }, {
        value: 'Ⅴ',
        label: '小二型'
      }, {
        value: 'large,middle',
        label: '大中型'
      }],
      Type: [{
        value: 1,
        label: '正常蓄水'
      }, {
        value: 2,
        label: '梅汛蓄水'
      }, {
        value: 3,
        label: '台汛蓄水'
      }],
      waterLabel: '',
      storageLabel: ''
    }
  },
  computed: {
  },
  methods: {
    changeWaterLabel () {
      this.waterLabel = this.storageType === 1 ? '汛限水位(m)' : this.storageType === 2 ? '梅汛水位(m)' : '台汛水位(m)'
    },
    changeStorageLabel () {
      this.storageLabel = this.storageType === 1 ? '汛限库容(万m³)' : this.storageType === 2 ? '梅汛库容(万m³)' : '台汛库容(万m³)'
    },
    getPartTime (date) {
      // console.log(date, 'time')
      let startIndex = date.indexOf('-')
      let endIndex = date.indexOf(':')
      return date.slice(startIndex + 1, endIndex + 3)
    },
    searchData () { // 查询，路由跳转出现问题
      this.tabledata()
      this.changeWaterLabel()
      this.changeStorageLabel()
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(reportAnalysisTypes.GET_DYNAMIC_RESERVOIR_STORAGE, {
        ReservoirScale: this.reservoirType,
        Time: this.seletdate,
        Type: this.storageType
      }).then(data => {
        this.tdata = data.rows
        this.loading = false
      })
    },
    exportdata () {
      this.$store.dispatch(reportAnalysisTypes.EXPORT_DYNAMIC_RESERVOIR_STORAGE, {
        sID: this.sID,
        ReservoirScale: this.reservoirType,
        Time: this.seletdate,
        Type: this.storageType
      }).then(data => {
        let blob = new Blob([data], { type: 'application/vnd.ms-excel' })
        let fileName = Date.parse(new Date()) + '.xls'
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        window.URL.revokeObjectURL(link.href)// 释放内存
        this.loading = false
      })
    },
    // rTime (date) {
    //   var jsonDate = new Date(date).toJSON()
    //   return new Date(new Date(jsonDate) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    // },
    getTime () {
      var date = new Date()
      var preDate = new Date(date.getTime() - 24 * 60 * 60 * 1000)
      var hour = date.getHours()
      if (hour < 8) { // 当前时间在8:00之前
        this.seletdate = this.$moment(preDate).format('YYYY-MM-DD 08:00')
        // this.seletdate = new Date(year, month - 1, day - 1, 8, 0)
      } else {
        this.seletdate = this.$moment(date).format('YYYY-MM-DD HH:00')
        // this.seletdate = new Date(year, month - 1, day, hour, 0)
      }
    }
  },
  mounted () {
    this.getTime()
    this.tabledata()
    this.changeWaterLabel()
    this.changeStorageLabel()
    this.timerFun = setInterval(() => {
      this.getTime()
      this.tabledata()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      // let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = contentDiv[0].offsetHeight - 45 + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20 + 'px'
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.monitor{
  overflow: hidden;
  .content{
    .yuliang{
      .select{
        display: flex;
        position: relative;
        .el-input{
          width: 165px;
        }
        .export {
          position: absolute;
          right: 0;
        }
        div.storageType{
          display: flex;
          justify-content: space-around;
          .desc {
            display: block;
            font-weight: bold;
            margin-right: 0 !important;
          }
          div{
            display: flex;
            // width:250px;
            height: 40px;
            overflow: hidden;
            justify-content: center;
             /deep/ div.el-radio-group .el-radio {
              line-height: 40px;
            }
          }
        }
        div.reservoirType{
          display: flex;
          .desc {
            display: block;
            font-weight: bold;
            margin-right: 0 !important;
          }
          div{
            display: flex;
            // width:350px;
            height: 40px;
            justify-content: center;
            /deep/ div.el-radio-group .el-radio {
              line-height: 40px;
            }
          }
        }
         div.time{
           .desc {
             font-weight: bold;
           }
          div{
            width:200px;
          }
        }
      }
    }
  }
}
// 样式穿透
.content /deep/ .yuliang .raintable .el-table .warning-row{
  background:#f3f364 !important;
}
#station{
  width: 100%;
  height: 400px;
}
.block{
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
.chartshuiwei{
    text-align: center;
    width: 100%;
    // text-align: center;
  }
</style>
